function cleanInput(input: string): string {
    let encodedValue = input;
    encodedValue = encodedValue.replace(/&/g, "%26");
    encodedValue = encodedValue.replace(/#/g, "%23");
    encodedValue = encodedValue.replace(/\+/g, "%2B");
    return encodedValue;
  }

  export default cleanInput;